import "../../Style/Home.scss";
import { gsap } from "gsap";
import { useEffect, useState } from "react";
import ScrollTrigger from "gsap/ScrollTrigger";
import { HashLink } from "react-router-hash-link";
import cld from "../../config/cloudcf";
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
function Home() {
  gsap.registerPlugin(ScrollTrigger);
  useEffect(() => {
    gsap.to(".h1", {
      opacity: 1,
      duration: 2,
      delay: 4,
    });
    gsap.to(".image", {
      opacity: 2,
      duration: 2,
      delay: 4.5,
    });
    gsap.to(".Content-Section", {
      scrollTrigger: {
        trigger: ".Content-Section",
        start: "20px 80%",
        end: "bottom 100px",
      },
      width: "100%",
      duration: 1,
      ease: "Power2.easeOut",
      delay: 0,
    });
    gsap.to(".img", {
      scrollTrigger: {
        trigger: ".Content-Section",
        start: "20px 80%",
        end: "bottom 100px",
      },
      opacity: 2,
      duration: 1,
      delay: 1,
      ease: "Power2.easeOut",
    });
    gsap.from(".p-sec-2", {
      x: -600,
      opacity: 0,
    });

    gsap.to(".p-sec-2", {
      scrollTrigger: {
        trigger: ".Content-Section",
        start: "20px 80%",
        end: "bottom 100px",
      },
      x: 0,
      opacity: 1,
      duration: 1,
      delay: 1,
      ease: "Power2.easeOut",
    });
    gsap.from(".btn-sec-2", {
      x: -600,
      opacity: 0,
    });
    gsap.to(".btn-sec-2", {
      scrollTrigger: {
        trigger: ".Content-Section",
        start: "20px 80%",
        end: "bottom 100px",
      },
      x: 0,
      opacity: 1,
      duration: 1,
      delay: 1,
      ease: "Power2.easeOut",
    });
  });
  const banners = [
    {
      image:
        "https://res.cloudinary.com/doy2qixs5/image/upload/v1745752831/rbn/home/slider/batavia-apartment_pgrlwh.jpg",
      text: "Leading with Technology.\nSustaining the Earth.\nElevating Output.",
    },
    {
      image:
        "https://res.cloudinary.com/doy2qixs5/image/upload/v1745752830/rbn/home/slider/pim1-exterior_kl1mrh.jpg",
      text: "Innovating with Purpose.\nShaping Tomorrow.\nBuilding Today.",
    },
    {
      image:
        "https://res.cloudinary.com/doy2qixs5/image/upload/v1745752830/rbn/home/slider/indang-project_wpj6nf.jpg",
      text: "Transforming Ideas.\nEmpowering Communities.\nDriving Progress.",
    },
  ];
  return (
    <div className="Home-Container">
      <div className="Home-Wrapper">
        <div className="Home-Section-1">
          <Swiper
            modules={[Autoplay, Pagination, Navigation]}
            spaceBetween={30}
            centeredSlides={true}
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
            }}
            pagination={{ clickable: true }}
            navigation={true}
            className="mySwiper"
          >
            {banners.map((banner, index) => (
              <SwiperSlide key={index}>
                <div className="Img-Container">
                  <img
                    className="image"
                    src={banner.image}
                    alt={`Banner ${index}`}
                  />
                  <motion.div
                    className="block"
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ duration: 2, delay: 0.5 }}
                    viewport={{ once: true }}
                  >
                    {banner.text.split("\n").map((line, idx) => (
                      <div key={idx}>{line}</div>
                    ))}
                  </motion.div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        <div className="Home-Section-2">
          <div className="Content-Section">
            {/* Left Image */}
            <div className="Image-Hover-Wrapper">
              <img
                className="img"
                src="https://res.cloudinary.com/doy2qixs5/image/upload/v1745492635/rbn/projects/australia/onslow_rjigsy.jpg"
                alt="Image 1"
              />
              <div className="Hover-Text">
                <h3>Risjadson Land</h3>
                <p>
                  PT Risjadson Land, established in 1992 by Risjadson Group,
                  focuses on real estate and construction. In 2022, the company
                  adopted Modern Method of Construction (MMoC) to deliver more
                  sustainable, cost-efficient, and precise projects, especially
                  in developing regions. Risjadson Land has since expanded
                  operations to Malaysia, the Philippines, and Australia.
                </p>
                <HashLink
                  smooth
                  to="/about#risjadsonland"
                  className="Hover-Button"
                >
                  More
                </HashLink>
              </div>
            </div>

            {/* Right Image */}
            <div className="Image-Hover-Wrapper">
              <img
                className="img"
                src="https://res.cloudinary.com/doy2qixs5/image/upload/v1678639491/rbn/about/Car-4.png"
                alt="Image 2"
              />
              <div className="Hover-Text">
                <h3>RCON</h3>
                <p>
                  RCON (PT. Risjadson Bhumi Nusantara) is a company subsidiary
                  of PT Risjadson Land. The company is in an expansion drive
                  through the manufacturing of modular housing to overcome
                  weakness in the traditional construction method. RCON has been
                  undertaking high level of projects, showcasing dedication to
                  building landmark national and international projects.
                </p>
                <HashLink smooth to="/about#risjadcon" className="Hover-Button">
                  More
                </HashLink>
              </div>
            </div>
          </div>
        </div>

        <div className="Home-Section-3">
          <motion.div
            initial={{
              opacity: 0,
            }}
            whileInView={{
              opacity: 1,
            }}
            transition={{
              duration: 1,
            }}
            viewport={{
              once: true,
            }}
            className="Our-Vision"
          >
            <div className="context">
              <div className="Section-3-Left">
                <motion.p
                  initial={{
                    opacity: 0,
                  }}
                  whileInView={{
                    opacity: 1,
                  }}
                  transition={{
                    duration: 1,
                    delay: 0.2,
                  }}
                  viewport={{
                    once: true,
                  }}
                >
                  Our Vision
                </motion.p>
              </div>
              <div className="Section-3-Right">
                <motion.p
                  initial={{
                    opacity: 0,
                  }}
                  whileInView={{
                    opacity: 1,
                  }}
                  transition={{
                    duration: 1,
                    delay: 0.2,
                  }}
                  viewport={{
                    once: true,
                  }}
                >
                  To be the world's leading and trusted contractor. We provide
                  the best transformative manufacturing solution for the
                  Construction and Property sector through the adoption of
                  Modern Method of Construction. We embrace and prioritize the
                  transition towards sustainable development projects.
                </motion.p>
              </div>
            </div>
          </motion.div>
          {/* <motion.div
            initial={{
              opacity: 0,
            }}
            whileInView={{
              opacity: 1,
            }}
            transition={{
              duration: 1,
            }}
            viewport={{
              once: true,
            }}
            className="Our-Mission"
          >
            <div className="context">
              <div className="Section-3-Left">
                <motion.p
                  initial={{
                    opacity: 0,
                  }}
                  whileInView={{
                    opacity: 1,
                  }}
                  transition={{
                    duration: 1,
                    delay: 0.4,
                  }}
                  viewport={{
                    once: true,
                  }}
                >
                  Our Mission
                </motion.p>
              </div>
              <div className="Section-3-Right">
                <motion.p
                  initial={{
                    opacity: 0,
                  }}
                  whileInView={{
                    opacity: 1,
                  }}
                  transition={{
                    duration: 1,
                    delay: 0.4,
                  }}
                  viewport={{
                    once: true,
                  }}
                >
                  To implement the next-generation property development and
                  construction projects that embrace the transformative power of
                  a scalable and sustainable digital project ecosystem platform,
                  enabled by the adoption of modern methods construction (MMoC)
                  and IR4.0 technologies in our integrated BIM-based
                  Design-Assemble-Manage (DAM) Project Delivery Model
                </motion.p>
              </div>
            </div>
          </motion.div> */}
        </div>
        <div className="Home-Section-4">
          <div className="Our-Projects">
            <motion.h2
              initial={{
                opacity: 0,
              }}
              whileInView={{
                opacity: 1,
              }}
              transition={{
                duration: 2,
                delay: 0.2,
              }}
              viewport={{
                once: true,
              }}
            >
              Our Projects Location
            </motion.h2>
          </div>
          <div className="Box-1">
            <div className="Kalimantan">
              <motion.div
                initial={{
                  opacity: 0,
                }}
                whileInView={{
                  opacity: 1,
                }}
                transition={{
                  duration: 1,
                  delay: 0.2,
                }}
                viewport={{
                  once: true,
                }}
                className="Text"
              >
                <HashLink
                  className="a"
                  to={"/experience#Indonesia"}
                  scroll={(el) => {
                    setTimeout(() => {
                      const yOffset = -100;
                      const y =
                        el.getBoundingClientRect().top +
                        window.pageYOffset +
                        yOffset;
                      window.scrollTo({ top: y, behavior: "smooth" });
                    }, 100); // Delay to ensure DOM is ready
                  }}
                >
                  <p>INDONESIA</p>
                  <img
                    src={
                      "https://res.cloudinary.com/doy2qixs5/image/upload/v1745760346/rbn/home/left_arrow.png"
                    }
                  />
                </HashLink>
              </motion.div>
              <div className="Rectangle"></div>
              <img
                src={
                  "https://res.cloudinary.com/doy2qixs5/image/upload/v1745732211/rbn/home/risjadson-land-rspi_d7iopg.jpg"
                }
              />
            </div>
          </div>
          <div className="Box-2">
            <div className="Bali">
              <motion.div
                initial={{
                  opacity: 0,
                }}
                whileInView={{
                  opacity: 1,
                }}
                transition={{
                  duration: 1,
                  delay: 0.2,
                }}
                viewport={{
                  once: true,
                }}
                className="Text"
              >
                <HashLink
                  to={"/experience#Philippines"}
                  className="a"
                  scroll={(el) => {
                    setTimeout(() => {
                      const yOffset = -100;
                      const y =
                        el.getBoundingClientRect().top +
                        window.pageYOffset +
                        yOffset;
                      window.scrollTo({ top: y, behavior: "smooth" });
                    }, 100); // Delay to ensure DOM is ready
                  }}
                >
                  <img
                    src={
                      "https://res.cloudinary.com/doy2qixs5/image/upload/v1745760346/rbn/home/left_arrow.png"
                    }
                  />
                  <p>PHILIPPINES</p>
                </HashLink>
              </motion.div>
              <div className="Rectangle"></div>
              <img
                src={
                  "https://res.cloudinary.com/doy2qixs5/image/upload/v1745732211/rbn/home/risjadson-land-philippines_twvdr7.jpg"
                }
              />
            </div>
          </div>
          <div className="Box-1">
            <div className="Kalimantan">
              <motion.div
                initial={{
                  opacity: 0,
                }}
                whileInView={{
                  opacity: 1,
                }}
                transition={{
                  duration: 1,
                  delay: 0.2,
                }}
                viewport={{
                  once: true,
                }}
                className="Text"
              >
                <HashLink
                  className="a"
                  to={"/experience#Australia"}
                  scroll={(el) => {
                    setTimeout(() => {
                      const yOffset = -100;
                      const y =
                        el.getBoundingClientRect().top +
                        window.pageYOffset +
                        yOffset;
                      window.scrollTo({ top: y, behavior: "smooth" });
                    }, 100); // Delay to ensure DOM is ready
                  }}
                >
                  <p>AUSTRALIA</p>
                  <img
                    src={
                      "https://res.cloudinary.com/doy2qixs5/image/upload/v1745760346/rbn/home/left_arrow.png"
                    }
                  />
                </HashLink>
              </motion.div>
              <div className="Rectangle"></div>
              <img
                src={
                  "https://res.cloudinary.com/doy2qixs5/image/upload/v1745732209/rbn/home/risjadson-land-cockburn_rna9ew.jpg"
                }
              />
            </div>
          </div>
          <div className="Box-2">
            <div className="Bali">
              <motion.div
                initial={{
                  opacity: 0,
                }}
                whileInView={{
                  opacity: 1,
                }}
                transition={{
                  duration: 1,
                  delay: 0.2,
                }}
                viewport={{
                  once: true,
                }}
                className="Text"
              >
                <HashLink
                  to={"/experience#Malaysia"}
                  className="a"
                  scroll={(el) => {
                    setTimeout(() => {
                      const yOffset = -100;
                      const y =
                        el.getBoundingClientRect().top +
                        window.pageYOffset +
                        yOffset;
                      window.scrollTo({ top: y, behavior: "smooth" });
                    }, 100); // Delay to ensure DOM is ready
                  }}
                >
                  <img
                    src={
                      "https://res.cloudinary.com/doy2qixs5/image/upload/v1745760346/rbn/home/left_arrow.png"
                    }
                  />
                  <p>MALAYSIA</p>
                </HashLink>
              </motion.div>
              <div className="Rectangle"></div>
              <img
                src={
                  "https://res.cloudinary.com/doy2qixs5/image/upload/v1745732210/rbn/home/risjadson-land-pertronas_aeape0.jpg"
                }
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
